import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class CheckMaxFreespinsReached extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();

        let maxReached = false;

        // Record triggered free spins but didn't award any more spins, so it must have been capped
        if (record instanceof FreespinRecord && record.freespinsTriggered && record.freespinsWon === 0) {
            maxReached = true;
        }

        return maxReached ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/decisions/check-max-freespins-reached.ts